import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";
import { TargetedCheckInsContext } from "contexts/TargetedCheckIns";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import ThreadPreview from ".";

const MobileThreadPreview = () => {
  const navigate = useNavigate();
  const closeFullScreen = () => {
    navigate(`/${routes.inboxCheckins}`);
  };
  const { actionItem } = useContext(TargetedCheckInsContext);

  return (
    <Dialog open={true} fullScreen>
      <DialogTitle sx={{ backgroundColor: "secondary.light", py: 1 }}>
        <Grid alignItems="center" container justifyContent="space-between">
          {actionItem?.brandName}
          <IconButton
            onClick={closeFullScreen}
            sx={{ fontSize: 12, color: "black" }}
          >
            <Box component="i" className="fa-regular fa-xmark" />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ px: 0 }}>
        <ThreadPreview />
      </DialogContent>
    </Dialog>
  );
};

export default MobileThreadPreview;
